import styled from "styled-components";

export const CarouselContainer = styled.div`
  position: relative;
  width: 50%;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);

  @media (max-width: 1400px) {
    min-width: 85%;
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transition: transform 0.8s ease-in-out, opacity 0.8s ease-in-out;

  ${({ $index, $activeIndex }) => `
    transform: translateX(${($index - $activeIndex) * 100}%);
    opacity: ${$index === $activeIndex ? 1 : 0.6};
    z-index: ${$index === $activeIndex ? 2 : 1};
  `}
`;
